import type { Company } from 'types/Company';

/**
 * Company option name constants — mirrors CompanyOption constants in bidops-app.
 * Use these instead of hardcoding option name strings.
 */
export const ADMIN_CHANNEL_OPT_IN = 'Admin Channel Opt-in';
export const HIDE_AMOUNT_FEEDBACK = 'Hide Amount Feedback';
export const HIDE_RANK_FEEDBACK = 'Hide Rank Feedback';

/** Whether the company has the named boolean option checked (`option_value === 'true'`). */
export const isCompanyOptionEnabled = (company: Company | undefined, optionName: string): boolean => Boolean(
  company?.company_options?.some(opt => opt.name === optionName && opt.option_value === 'true')
);
